


























import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class ContentHolder extends Vue {
  @Prop({ default: "" })
  private title!: string;

  @Prop({ default: "" })
  private cta!: string;

  @Prop({ default: false })
  private grey!: boolean;

  @Prop({ default: "" })
  private ctaClass!: string;

  @Prop({ default: "" })
  private ctaIcon!: string;

  @Prop({ default: false })
  private ctaDisabled!: boolean;

  @Prop({ default: false })
  private ctaLoading!: boolean;

  public get ctaCssClass() {
    if (this.ctaClass) {
      return this.ctaClass;
    }
    if (this.grey) {
      return "has-text-grey-light";
    }
    return "button is-rounded is-outlined";
  }
}
